/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_ItemInputs */

const id_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ms_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const da_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const de_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const en_us2_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const es_es2_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítem`)
};

const es_mx2_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítem`)
};

const fil_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const fr_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const it_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articolo`)
};

const hu_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elem`)
};

const nl_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const no_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const pl_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const pt_br2_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const pt_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ro_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const fi_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohde`)
};

const sv_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt`)
};

const vi_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục`)
};

const tr_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğe`)
};

const cs_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položka`)
};

const bg_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обект`)
};

const ru_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объект`)
};

const uk_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елемент`)
};

const ar_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنصر`)
};

const hi_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम`)
};

const th_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการ`)
};

const ja_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム`)
};

const zh_cn2_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const zh_hant1_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const ko_home_pulse_badge_item = /** @type {(inputs: Home_Pulse_Badge_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템`)
};

/**
* | output |
* | --- |
* | "Item" |
*
* @param {Home_Pulse_Badge_ItemInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_item = /** @type {((inputs?: Home_Pulse_Badge_ItemInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_ItemInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_item(inputs)
	if (locale === "ms") return ms_home_pulse_badge_item(inputs)
	if (locale === "da") return da_home_pulse_badge_item(inputs)
	if (locale === "de") return de_home_pulse_badge_item(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_item(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_item(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_item(inputs)
	if (locale === "fil") return fil_home_pulse_badge_item(inputs)
	if (locale === "fr") return fr_home_pulse_badge_item(inputs)
	if (locale === "it") return it_home_pulse_badge_item(inputs)
	if (locale === "hu") return hu_home_pulse_badge_item(inputs)
	if (locale === "nl") return nl_home_pulse_badge_item(inputs)
	if (locale === "no") return no_home_pulse_badge_item(inputs)
	if (locale === "pl") return pl_home_pulse_badge_item(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_item(inputs)
	if (locale === "pt") return pt_home_pulse_badge_item(inputs)
	if (locale === "ro") return ro_home_pulse_badge_item(inputs)
	if (locale === "fi") return fi_home_pulse_badge_item(inputs)
	if (locale === "sv") return sv_home_pulse_badge_item(inputs)
	if (locale === "vi") return vi_home_pulse_badge_item(inputs)
	if (locale === "tr") return tr_home_pulse_badge_item(inputs)
	if (locale === "cs") return cs_home_pulse_badge_item(inputs)
	if (locale === "bg") return bg_home_pulse_badge_item(inputs)
	if (locale === "ru") return ru_home_pulse_badge_item(inputs)
	if (locale === "uk") return uk_home_pulse_badge_item(inputs)
	if (locale === "ar") return ar_home_pulse_badge_item(inputs)
	if (locale === "hi") return hi_home_pulse_badge_item(inputs)
	if (locale === "th") return th_home_pulse_badge_item(inputs)
	if (locale === "ja") return ja_home_pulse_badge_item(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_item(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_item(inputs)
	return ko_home_pulse_badge_item(inputs)
});
export { home_pulse_badge_item as "home.pulse.badge.item" }